module.exports = __webpack_public_path__ + "static/media/rp3-logo.7a2858e7.svg";